import { BaseModel } from './base.model'

export class InteractiveContentItemTransitionSkill extends BaseModel<InteractiveContentItemTransitionSkill> {
  static DEFAULT_ATTRIBUTES = {}

  _destroy: boolean
  id: number
  interactiveContentItemTransitionId: number
  skillId: number
  pointsCount: number
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/interactive-content-item-transition-skill.model.ts